import axios from 'axios'
import store from '@/store'

export default {
  getTasks (params) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/tasks', {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          },
          params
        })
        .then(
          res => {
            store.dispatch('tasks/setTasks', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  createLogTime (params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/tasks`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  updateTask (id, params) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/tasks/${id}`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  removeTask (id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/tasks/${id}`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  }
}
